import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import PayrollSystemsWrapper from "@components/layouts/payrollSystemsWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function InsureYourCarHome(): ReactElement {
    return (
        <PayrollSystemsWrapper>
            <PrivacyPolicy
                category="Payroll Systems"
                domain="PayrollSystems.com"
            />
        </PayrollSystemsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
